
import { computed, defineComponent } from 'vue';
import { ISpacesContact } from '@/types/interfaces';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import { useMainStore } from '@/store/mainStore';
import { useMessagesStore } from '@/modules/messages/store/messagesStore';
import SpacesService from '@/modules/spaces/services/SpacesService';
import { PHOTO_VIEW_TYPE } from '@/types/enums';

export default defineComponent({
  props: {
    contact: { type: Object as () => ISpacesContact, required: true },
    invitedUserIds: { type: Array, required: false },
  },
  emits: ['select', 'invite-to-group'],
  setup(props, { emit }) {
    const mainStore = useMainStore();
    const messagesStore = useMessagesStore();

    const photoUrl = computed(() => {
      if (props.contact.photo) {
        return lowResUrlByViewTypeByUrl(props.contact.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    const fullName = computed(() => `${props.contact.firstName} ${props.contact.lastName}`);
    const groupMember = computed(
      () => messagesStore.currentConversation?.group?.members.find((member) => member.accountId === props.contact.accountId),
    );

    /** Boolean is true if the contact is invited to the current group */
    const invitedToGroup = computed(() => props.invitedUserIds?.includes(props.contact.accountId));

    function inviteUserToGroup(): void {
      emit('invite-to-group', props.contact);
    }

    function removeUserFromGroup() {
      if (messagesStore.currentConversation?.group?.id) {
        SpacesService.deleteUserFromGroup(messagesStore.currentConversation?.group?.id, props.contact.accountId).then((response) => {
          console.log(response);
        });
      }
    }

    return {
      photoUrl,
      fullName,
      groupMember,
      inviteUserToGroup,
      removeUserFromGroup,
      invitedToGroup,
    };
  },
});
